import SntBubble from './SntBubble.vue'

export { SntBubble }
export default {
  $_shipnity_subcomponents: {
    SntBubble
  }
}
